__turbopack_context__.v({
  "closeButton": "InfluenceTargetPaper-module__8YHu3q__closeButton",
});
